var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
export default function QuoteRequestsList() {
    var _this = this;
    var page = useParams().page;
    var navigate = useNavigate();
    var _a = useState('all'), filter = _a[0], setFilter = _a[1];
    var _b = useState([]), devisRequests = _b[0], setDevisRequests = _b[1];
    // Map numeric status from API to readable labels and Bootstrap badge classes
    var getStatusInfo = function (status) {
        switch (status) {
            case 1:
                return { label: 'Initiated', badgeClass: 'bg-warning text-dark' };
            case 2:
                return { label: 'Pending', badgeClass: 'bg-info text-dark' };
            case 3:
                return { label: 'Quoted', badgeClass: 'bg-info text-dark' };
            case 4:
                return { label: 'Distributed', badgeClass: 'bg-primary' };
            default:
                return { label: "Status ".concat(status), badgeClass: 'bg-light text-dark' };
        }
    };
    // Helper to format GMT date nicely
    var formatDate = function (dateString) {
        if (!dateString)
            return 'N/A';
        return new Date(dateString).toLocaleDateString('fr-FR', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    };
    useEffect(function () {
        getDevisRequests(page || '1').catch(function (err) {
            console.error('Failed to fetch devis requests:', err);
        });
    }, [page]);
    var getDevisRequests = function (page) { return __awaiter(_this, void 0, void 0, function () {
        var response, res, mappedData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(App.api_base + '/devisQueue/' + page, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Vuedoo-Domain': App.domain,
                            'X-Vuedoo-Access-Key': ''
                        },
                    })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    res = _a.sent();
                    if (res.status === 'success') {
                        mappedData = res.data.map(function (block, index) { return (__assign({ id: block.id, status: (block.status === 1 ? 1 : block.status === 2 ? 2 : block.status === 3 ? 3 : block.status === 4 ? 4 : 0), title: "Request #".concat(index + 1) + block.title }, block)); });
                        setDevisRequests(mappedData);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    // Filter logic for the frontend tabs
    var filteredRequests = devisRequests.filter(function (req) {
        if (filter === 'all')
            return true;
        var statusInfo = getStatusInfo(req.status || 0);
        return statusInfo.label.toLowerCase() === filter;
    });
    return (_jsxs("div", { className: "container py-3 pb-5", style: { maxWidth: '600px' }, children: [_jsxs("div", { className: "d-flex justify-content-between align-items-center mb-4", children: [_jsx("h4", { className: "fw-bold text-primary mb-0", children: "Devis Requests" }), _jsxs("span", { className: "badge bg-primary rounded-pill", children: [devisRequests.length, " Total"] })] }), _jsx("div", { className: "d-flex gap-2 overflow-auto pb-3 mb-2", style: { scrollSnapType: 'x mandatory' }, children: ['all', 'pending', 'quoted', 'distributed', 'cancelled'].map(function (tab) { return (_jsx("button", { onClick: function () { return setFilter(tab); }, className: "btn btn-sm px-3 py-2 rounded-pill flex-shrink-0 fw-semibold ".concat(filter === tab ? 'btn-primary' : 'btn-outline-secondary'), style: { scrollSnapAlign: 'start', textTransform: 'capitalize' }, children: tab === 'all' ? 'All' : tab }, tab)); }) }), _jsx("div", { className: "d-flex flex-column gap-3", children: filteredRequests.length === 0 ? (_jsx("div", { className: "text-center text-muted py-5", children: _jsx("p", { className: "mb-0", children: "No requests found for this filter." }) })) : (filteredRequests.map(function (req) {
                    console.log(req.status);
                    var statusInfo = getStatusInfo(req.status || 0);
                    return (_jsx("div", { className: "card shadow-sm border-0", style: { cursor: 'pointer', transition: 'transform 0.1s' }, onClick: function () { return navigate("/entry/".concat(req.slug)); }, children: _jsxs("div", { className: "card-body p-3", children: [_jsx("div", { className: "d-flex justify-content-end mb-2", children: _jsx("span", { className: "badge ".concat(statusInfo.badgeClass, " px-3 py-2"), children: statusInfo.label }) }), _jsx("div", { className: "mb-3", children: _jsx("h5", { className: "fw-bold mb-0 text-break", children: req.title }) }), _jsxs("div", { className: "d-flex flex-column gap-1 pt-2 border-top text-muted small", children: [_jsxs("div", { className: "d-flex justify-content-between", children: [_jsx("span", { className: "fw-semibold", children: "Initiated:" }), _jsx("span", { children: formatDate(req.created_at) })] }), _jsxs("div", { className: "d-flex justify-content-between", children: [_jsx("span", { className: "fw-semibold", children: "Last Modified:" }), _jsx("span", { children: formatDate(req.modified_at) })] })] })] }) }, req.id));
                })) })] }));
}
